import { useState, useCallback } from 'react';
import { alignmentPoints } from '../../../common/constants/alignment-types';
import axis from '../constants/axis';

function calculateStartPosition(elementBounds, position) {
  const rect = elementBounds;

  switch (position) {
    case alignmentPoints.BOTTOM:
      return {
        x: rect.left,
        y: rect.bottom,
      };

    case alignmentPoints.RIGHT:
      return {
        x: rect.right,
        y: rect.top,
      };

    case alignmentPoints.CENTER:
      return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      };
    case alignmentPoints.TOP:
    case alignmentPoints.LEFT:
    default:
      return {
        x: rect.left,
        y: rect.top,
      };
  }
}

const usePositioningCorrection = () => {
  const [axisXAlignment, setAxisXAlignment] = useState(null);
  const [axisYAlignment, setAxisYAlignment] = useState(null);

  const handleCorrectionUpdate = useCallback((correction) => {
    if (correction.meta.hasCorrection) {
      const { meta } = correction;

      let isYCorrectionApplied = false;
      let isXCorrectionApplied = false;

      meta.appliedCorrections.forEach((correctionMeta) => {
        const { axis: targetAxis, alignmentType, elementBounds } = correctionMeta;
        const [, alignmentSide] = alignmentType.split('-');
        const position = calculateStartPosition(elementBounds, alignmentSide);

        if (targetAxis === axis.X) {
          isXCorrectionApplied = true;
          setAxisXAlignment(position.x);
        } else if (targetAxis === axis.Y) {
          isYCorrectionApplied = true;
          setAxisYAlignment(position.y);
        }
      });

      if (!isXCorrectionApplied) {
        setAxisXAlignment(null);
      }

      if (!isYCorrectionApplied) {
        setAxisYAlignment(null);
      }
    } else {
      setAxisXAlignment(null);
      setAxisYAlignment(null);
    }
  }, []);

  /**
   * Resets all alignment corrections to zero
   */
  const resetPositioningCorrections = useCallback(() => {
    setAxisXAlignment(null);
    setAxisYAlignment(null);
  }, []);

  return {
    axisXAlignment,
    axisYAlignment,
    handleCorrectionUpdate,
    resetPositioningCorrections,
  };
};

export default usePositioningCorrection;
